// changeInputs = function (value) {
//   $('input#service_provider_lead_first_name').attr('disabled', value)
//   $('input#service_provider_lead_last_name').attr('disabled', value)
//   $('input#service_provider_email').attr('disabled', value)
//   $('input#service_provider_street').attr('disabled', value)
//   $('input#service_provider_zip').attr('disabled', value)
//   $('input#service_provider_city').attr('disabled', value)
//   $('select#service_provider_country').attr('disabled', value)
// }

// fillInputs = function (name) {
//   $.ajax('/partners/json_attributes', {
//     method: 'GET',
//     name,
//     done: function (data, ui) {
//       $('input#service_provider_first_name').val(data.lead_first_name)
//       $('input#service_provider_last_name').val(data.lead_last_name)
//       $('input#service_provider_email').val(data.email)
//       $('input#service_provider_street').val(data.street)
//       $('input#service_provider_zip').val(data.zip)
//       $('input#service_provider_city').val(data.city)
//       $('select#service_provider_country').val(data.country).trigger('change')
//       changeInputs(true)
//     }
//   })
// }

window['service_providers#show'] = function () {
  $(document).on('change', '.filter-process select#candidate_id, .filter-process select#event_type', function () {
    this.form.submit()
  })
}

// window['service_providers#new'] = function() {
//   $('input#service_provider_name').autocomplete({
//     minLength: 4,
//     source: '/partners/autocomplete_service_providers',
//     select: function(event, ui) { fillInputs(ui.item.value) },
//     search: changeInputs(false)
//   })
// };
